import { render, staticRenderFns } from "./Succeed.vue?vue&type=template&id=6502f6fe&scoped=true&"
import script from "./Succeed.vue?vue&type=script&lang=js&"
export * from "./Succeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6502f6fe",
  null
  
)

export default component.exports